'use strict';

/**
 * @doc module
 * @name util
 * @description
 *
 * amsApi.
 */

var app = angular.module('harriApp');


var CUSTOM_FILTER_SOURCES_LABELS = {
    "social_referral": "Employee Referral",
};

/**
 * amsApi
 */
app.factory('amsApi', ['$http', '$q', 'asyncGlobalHandler', 'httpHelper', 'positionsDataService',
    function ($http, $q, asyncGlobalHandler, httpHelper, positionsDataService) {

        var data = { };

        /**
         * getFilters
         *
         * @returns {*}
         */
        data.getFilters = function (brandId, jobId) {
            var defer = $q.defer();
            var promises = {};
            promises['filters'] = httpHelper.g('jobs/getActiveFilters');
            promises['activePositions'] = positionsDataService.getActivePositionsFlat(false, brandId);
            promises['job_sources_filter'] = BrandAPI.getBrandJobsApplicationSources(brandId, jobId);

            $q.all(promises).then(function (res) {
                var data = res.filters.data.data;
                data.positions.filters = res['activePositions'];
                if(res.job_sources_filter.sources.length > 0){
                    data.sources = {
                        'title': 'Sources',
                        'filters': res.job_sources_filter.sources.map(function(item){
                            return {
                                'id': item.code,
                                'name': CUSTOM_FILTER_SOURCES_LABELS[item.code]? CUSTOM_FILTER_SOURCES_LABELS[item]:
                                    item.name
                            };
                        })
                    };
                }
                defer.resolve(data);
            });

            return defer.promise;
        };

        /**
         * getUserLocations
         *
         * @returns {*}
         */
        data.getUserLocations = function (groupId) {
            return httpHelper.g('groups/' + groupId + '/user/brands');
        };

        /**
         * removeInterview
         *
         * @deprecated
         *
         * @param ids
         * @returns {*}
         */
        data.removeInterview = function (ids) {
            return httpHelper.p('job_applications/interview', {
                "interview_id": ids
            });
        };

        data.getSortOption = function(job_id){
            return httpHelper.g('ams/sort_option/'+job_id);
        };


        /**
         * getALlOpenCalls
         *
         * @param job_id
         * @returns {*}
         */
        data.getAllOpenCalls = function (job_id) {
          return httpHelper.g('jobs/opencall_details/' + job_id);
        };


        /**
         * getBrandOpenCalls
         *
         * @param job_id
         * @returns {*}
         */
        data.getBrandOpenCalls = function (brand_id) {
          if (brand_id) {
            return httpHelper.g('brand/opencalls/' + brand_id);
          }
          else {
            return false;
          }
        };

        return data;
    }]);
